import { useEffect } from "react";

function ReturnOrder() {
  useEffect(() => {
    // Load Termly script only once
    if (!document.getElementById("termly-jssdk")) {
      const script = document.createElement("script");
      script.id = "termly-jssdk";
      script.src = "https://app.termly.io/embed-policy.min.js";
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div className="return-wrapper">
      {/* Termly Embed */}
      <div
        name="termly-embed"
        data-id="511c6e2e-6a10-4ad2-84ca-05450cbfea69"
      ></div>
    </div>
  );
}

export default ReturnOrder;
